import Splide, { CLASSES } from '@splidejs/splide';
import classNames from 'classnames';

const defaultOptions = {
	classes: {
		pagination: 'ona-slider__pagination',
		page: 'ona-slider__pagination-dot',
		arrows: 'ona-slider__arrows',
	},
	gap: 'var(--ona-slider-gap, 0)',
	arrows: false,
	pagination: false,
	drag: 'free',
	autoplay: true,
	speed: 1500,
};

export const initSlider = (element, options = {}) => {
	const { classes, extensions = {}, ...rest } = options;

	if (classes) {
		Object.entries(classes).forEach(([key, value]) => {
			classes[key] = classNames(
				Splide.defaults.classes?.[key] || CLASSES?.[key],
				defaultOptions.classes?.[key],
				value
			);
		});
	}
	return new Splide(element, { ...defaultOptions, ...rest }).mount(
		extensions
	);
};

document.querySelectorAll('.ona-slider[data-splide]').forEach((sliderEl) => {
	initSlider(sliderEl);
});
